// @flow

import React, { Component } from 'react';
import type { SeasonListType } from 'types/Seasons';
import type { CompetitionType } from 'types/Competitions';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';

type Props = {
  slug: string,
  seasons: Array<SeasonListType>,
  onFilterChange: (filters: Object) => void,
  initialFilters: Object | null,
  defaultSeason: string,
  competitions?: Array<CompetitionType>
};

type State = {
  equipe: string,
  season: number,
  competitions?: Array<any>,
};

export default class CompetitionsFilters extends Component<Props, State> {
  props: Props;
  state: State = {
    equipe: this.props.slug,
    season: 0,
    competitions: [],
  };

  convertToOptions = (options: Array<Object>, reverseBool?: boolean): Array<Object> => {
    const dropdownOptions = options.map((option): Object => ({label: option.title, value: option.id}));
    return reverseBool ? dropdownOptions.reverse() : dropdownOptions;
  }

  convertToSeasonsOptions = (options: Array<Object>, reverseBool?: boolean): Array<Object> => {
    const dropdownOptions = options.map((option): Object => ({label: option.name, value: option.id}));
    return reverseBool ? dropdownOptions.reverse() : dropdownOptions;
  }

  selectSeason = (value: string) => {
    const { onFilterChange } = this.props;
    const season = parseInt(value, 10);
    this.setState((prevState: State) => ({
      ...prevState,
      competitions: [],
      season
    }), () => onFilterChange(this.state));
  };

  getLabelSeason = () => {
    const { seasons } = this.props;
    const { season } = this.state;
    const prelabel = seasons.filter((saison) => saison.id === season);
    return prelabel.length === 1 ? prelabel[0].name : this.props.defaultSeason ;
  }

  onInputChange = (filterType: string, value: string) => {
    const { onFilterChange } = this.props;
    this.setState((prevState: State) => {
      let newState = [];
      const filters = prevState[filterType];

      if (filters.includes(value)) {
        newState = filters.filter(filter => filter !== value);
      } else {
        newState = [...filters, value];
      }

      return {
        ...prevState,
        [filterType]: newState,
      };
    }, () => onFilterChange(this.state));
  };

  componentDidMount = () => {
    const { initialFilters } = this.props;

    if (initialFilters) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...initialFilters,
      }));
    }
  };

  render() {
    const { seasons, competitions } = this.props;
    const { competitions: competitionsState } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col">
            <div className="header-filter header-filter--team header-filter--teamWfilter mt-2">
              <div className="row">
                <div className="col col-lg-8on9">
                  <div className="header-filter__left">
                  { seasons && seasons.length > 0 &&
                    <DropdownRadioInput
                      prelabel={'Saison '}
                      label={this.getLabelSeason()}
                      id="Saisons"
                      options={this.convertToSeasonsOptions(seasons, true)}
                      inputChanged={this.selectSeason}
                      noBorder
                      maj
                      title
                      isPreLabelThin={false}
                    /> }
                    { competitions && competitionsState && <DropdownMultiInput
                        label="Toutes les compétitions"
                        id="Compétitions"
                        options={this.convertToOptions(competitions)}
                        inputChanged={(value) => this.onInputChange('competitions', value)}
                        selected={competitionsState}
                        className={'dropdown dropdown--noBorder dropdown--checkbox'}
                      />}
                  </div>
                </div>
              </div>
            </div>
            <div className="header-filter__sep mb-6"/>
          </div>
        </div>
      </React.Fragment>
    );
  }
};
